<template>
  <div class="full-height" v-loading="anomaliesReqStatus === 'loading'">
    <div class="table-toolbar" v-if="anomaliesReqStatus === 'saved'">
      <table-toolbar
        :key="anomalies.key"
        v-if="visibleColumns"
        :search-properties="visibleColumns"
        :total-search-properties="columns"
        :search-data="anomalySummary.anomalyRules"
        :initial-tags="anomalySummary.anomalyRules.searchTags"
        :reload-component="anomalySummary.anomalyRules.reloadToolbar"
        :active-filter-data="activeFiltersData"
        :disable-search-box="disableSearchBox"
        @refresh-tabledata="fetchAnomalies"
        @update-querydata="updateTableQueryData"
        @update-columns-data="modifyColumnsData"
        @add-searchtags="addSearchTags"
        @deactivate-filter="deactivateFilter"
      >
        <div slot="left-toolbar-tools" class="filter-button-group">
          <span v-if="filterList.length">
            <div class="display-inline mr-18 relative-pos" v-for="(btn, index) in filterList" :key="index">
              <el-input
                ref="customFilterInput"
                class="filter-input"
                v-if="btn.editFlag"
                placeholder="+Name"
                v-model="btn.name"
                @change.native.stop="handleFilterNameChange(btn)"
                @keyup.native.enter="handleFilterNameChange(btn)"
                @blur="handleFilterNameChange(btn)"
              ></el-input>
              <el-button
                v-else
                size="small"
                round
                :class="{'active': btn.active}"
                :id="btn.id"
                @click="changeState(btn)"
              >
                {{ btn.name}}
                <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                <span>
                  <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                  <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                </span>
                </el-tooltip>
              </el-button>

              <span v-if="btn.errFlag" class="filter-name-validator">{{filterErrMsg}}</span>
            </div>
          </span>
        </div>
      </table-toolbar>
    </div>

    <action-table-element
      v-if="anomaliesReqStatus === 'saved'"
      ref="anomaliesTable"
      class="anomalies-table"
      :actions="tableActions"
      :columns="visibleColumns"
      :table-data="anomalySummary.anomalyRules"
      :height-offset="40"
      @update-record-count="recordCountHandler"
    ></action-table-element>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { anomalyRulesMetaInfo } from '@/column-header/anomalies/anomaly-rules-meta'
import {
  ANOMALIES_LIST_REQ,
  ANOMALIES_SUMMARY_REQ,
  ANOMALIES_LIST_SUCCESS,
  ENABLE_ANOMALY_RULE_REQ,
  ANOMALIES_RULE_VIEW_PREFERENCES_REQ,
  SAVE_ANOMALIES_RULE_VIEW_PREFERENCES
} from '@/store/modules/anomalies/anomalies.type'
import { AGENT_LIST_REQ } from '@/store/modules/agents/agents.type'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import customFilterMixin from '@/mixins/customFilterMixin'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import ActionTableElement from '@/components/table/ActionTableElement.vue'
import BasicTableElement from '@/components/table/BasicTableElement.vue'

export default {
  name: 'AnomalyRules',
  mixins: [loadDocumentationMixin, customFilterMixin],
  components: {
    PageHeaders,
    TableToolbar,
    ActionTableElement,
    BasicTableElement
  },
  data () {
    return {
      anomaliesRuleColumnPrefs: {},
      tableName: "Anomalies_Rules",
      columns: anomalyRulesMetaInfo.meta.columns,
      visibleColumns: [],
      tableActions: [
        {
          name: 'pause',
          icon: 'c-icon far fa-pause-circle',
          tooltip: 'Enable/Disable Anomaly Rule',
          rbac: {
            subject: 'rules',
            operation: 'write'
          },
          actionHandler: selection => {
            let vm = this
            let pause = selection.row.state === 'ENABLED' ? 'Disable' : 'Enable'
            let anomalyTypeDesc = selection.row.anomalyType.toLowerCase().replaceAll('_', ' ')
            this.$confirm(`This will ${pause.toLowerCase()} ${anomalyTypeDesc}. Continue?`, `${pause} anomaly rule`, {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              callback: function (action) {
                if (action === 'confirm') {
                  vm.pauseAccount(selection.row)
                } else if (action === 'cancel') {
                  vm.$message({
                    type: 'info',
                    message: `Operation canceled`
                  })
                }
              }
            })
          }
        }
      ],
      tblId: 8
    }
  },
  created () {
    if (this.anomaliesReqStatus !== 'saved') {
      this.fetchAnomalies()
    }
    this.loadAnomaliesRuleColumnPreferences()
  },
  methods: {
    fetchAnomalies () {
      if (this.agentListReqStatus !== 'saved') {
        this.$store.dispatch(AGENT_LIST_REQ).then(resp => {
          Promise.all([this.$store.dispatch(ANOMALIES_LIST_REQ), this.$store.dispatch(ANOMALIES_SUMMARY_REQ)]).then(
            collection => {
              this.$store.dispatch(ANOMALIES_LIST_SUCCESS)
              this.updateTableQueryData()
            }
          )
        })
      } else {
        Promise.all([this.$store.dispatch(ANOMALIES_LIST_REQ), this.$store.dispatch(ANOMALIES_SUMMARY_REQ)]).then(
          collection => {
            this.$store.dispatch(ANOMALIES_LIST_SUCCESS)
            this.updateTableQueryData()
          }
        )
      }
    },
    updateTableQueryData () {
      if (this.$refs.anomaliesTable) {
        this.$refs.anomaliesTable.updateTableData()
      }
    },
    modifyColumnsData (selectedColumns) {
      this.anomaliesRuleColumnPrefs.userId = this.userProfile.id;
      this.anomaliesRuleColumnPrefs.tblName = this.tableName;
      this.anomaliesRuleColumnPrefs.preferedCols = selectedColumns.length === 0? NaN: selectedColumns;
      this.anomaliesRuleColumnPrefs.tblId = 8;

      this.visibleColumns = this.anomalies.updateVisibleColumns(this.columns, selectedColumns) 
      
      this.$store.dispatch(SAVE_ANOMALIES_RULE_VIEW_PREFERENCES, this.anomaliesRuleColumnPrefs).then(
        data => {
          // store preferences in vuex
          this.anomaliesRuleColumnPrefs.preferedCols = this.visibleColumns;
          this.$store.dispatch(PREFERENCE_STORE_REQ, this.anomaliesRuleColumnPrefs);
        })
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.anomalies.key = !this.anomalies.key
      this.anomalies.reloadToolbar = false
    },
    refreshTableData (tableMetaData) {
      this.fetchAnomalies(tableMetaData)
    },
    loadAnomaliesRuleColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(ANOMALIES_RULE_VIEW_PREFERENCES_REQ, this.userProfile.id)
          .then(data => {
            this.visibleColumns = this.columns.filter(col => {
              return this.anomaliesRulePreferences.includes(col.label)
            })
            this.updateStoreWithPrefs()
          })
      }
    },
    updateStoreWithPrefs () {
      this.anomaliesRuleColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.anomaliesRuleColumnPrefs);
    },
    pauseAccount (row) {
      this.$store
        .dispatch(ENABLE_ANOMALY_RULE_REQ, {
          ruleId: row.id,
          enable: row.state !== 'ENABLED'
        })
        .then(agents => {
          setTimeout(() => {
            this.refreshTableData({
              activePage: this.anomalySummary.anomalyRules.currentPage,
              searchTags: this.anomalySummary.anomalyRules.searchTags
            })
          }, 500)
        })
    }
  },
  computed: {
    ...mapGetters([
      'userProfile',
      'anomalySummaryReqStatus',
      'anomalySummary',
      'anomaliesReqStatus',
      'anomalies',
      'agentListReqStatus',
      'anomaliesRulePreferences',
      'userProfile',
      'userPref'
    ])
  },
  watch: {}
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/global_classes.css';
@import 'assets/styles/icon.css';
@import 'assets/styles/accounts_list.css';

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  right: 110px;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/anomalies/AnomalyRules.vue